<template>
  <div>
    <header>
      <h6 class="text-subtitle-1 text-md-h6 font-weight-bold mb-5 mb-md-8">
        ¿En qué cuenta querés recibir el pago?
      </h6>
    </header>
    <SkeletonForm v-if="isLoading" />
    <section v-else>
      <div
        v-for="account of technicianAccounts"
        :key="account.id"
        class="d-flex align-center justify-center justify-md-start mb-5 mb-md-6"
        style="gap: 1rem"
      >
        <v-radio-group v-model="formData.cbu">
          <v-radio :value="account.id" color="blue darken-2"></v-radio>
        </v-radio-group>
        <v-card class="d-flex flex-column" elevation="0">
          <span class="text-subtitle-2 text-md-subtitle-1 font-weight-bold"
            >Nombre y Apellido:
            <span class="font-weight-regular"
              >{{ account.nombre_prestador }}
              {{ account.apellido_prestador }}</span
            ></span
          >
          <span class="text-subtitle-2 text-md-subtitle-1 font-weight-bold"
            >CUIT:
            <span class="font-weight-regular">{{ account.cuit }}</span></span
          >
          <span class="text-subtitle-2 text-md-subtitle-1 font-weight-bold"
            >Banco:
            <span class="font-weight-regular">{{ account.banco }}</span></span
          >
          <span class="text-subtitle-2 text-md-subtitle-1 font-weight-bold"
            >CBU:
            <span class="font-weight-regular">{{ account.cbu }}</span></span
          >
          <v-alert
            v-if="validatedCUIT && account.cuit === validatedCUIT"
            type="success"
            dense
            text
            class="mt-2"
          >
            Mismo CUIT que la factura cargada
          </v-alert>
        </v-card>
      </div>
    </section>
    <p
      class="subtitle-1 red--text darken-4 font-weight-medium"
      v-if="cbuErrors?.length"
    >
      {{ cbuErrors[0] }}
    </p>
  </div>
</template>

<script>
import SkeletonForm from "@/components/SkeletonForm.vue";
import { mapActions, mapState } from "vuex";
export default {
  name: "SecondStep",
  props: {
    formData: {
      type: Object,
      required: true,
    },
    v: {
      type: Object,
      required: true,
    },
  },
  components: { SkeletonForm },
  computed: {
    ...mapState("invoice", [
      "isLoading",
      "technicianAccounts",
      "validatedCUIT",
    ]),

    cbuErrors() {
      const errors = [];
      if (!this.v.cbu.$error) return errors;
      !this.v.cbu.required && errors.push("Debe seleccionar una cuenta");
      return errors;
    },
  },
  async mounted() {
    await this.getTechnicianAccounts();
  },
  methods: {
    ...mapActions("invoice", ["getTechnicianAccounts"]),
  },
  watch: {
    technicianAccounts: {
      handler(newAccounts) {
        if (this.formData.cbu) return;
        const preselect = newAccounts.find((account) => {
          return account.cuit === this.validatedCUIT;
        });
        if (preselect) {
          this.formData.cbu = preselect.id;
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style></style>
